<template>

    <div class="infoframe">
        <div class="infohead">
            <div style="margin-left:32px">
               友邦 出签
            </div>
        </div>
        
        <el-form ref="form"  label-width="80px" class="infoform">
             <el-form-item label="兑换码">
                <el-input v-model="CustomerID" :disabled="true" ></el-input>
            </el-form-item>
            <el-form-item label="证件类型">
              <el-select v-model="PaperType" placeholder="请选择" @change="IDChange">
    <el-option
      v-for="item in IDOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            <el-form-item label="证件号码">
                <el-input v-model="PaperValue" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="客户姓名">
                <el-input  v-model="Name"></el-input>
            </el-form-item>
             <el-form-item label="客户性别">
              <el-select v-model="Sex" placeholder="请选择" :disabled="isSex" @change="SexChange">
    <el-option
      v-for="item in SexOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input  v-model="Mobile" maxlength="11"></el-input>
            </el-form-item>
             <el-form-item label="出生日期">
                <el-date-picker
      v-model="BirthDay" value-format="yyyy-MM-dd"
      type="date"
      placeholder="选择出生日期" :disabled="isBirthDay">
    </el-date-picker>
            </el-form-item>
            
            <el-form-item label="产品编号">
              <el-select v-model="product" placeholder="请选择">
    <el-option
      v-for="item in ddlproduct"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item>
               <!-- <el-form-item label="健康顾问">
              <el-select v-model="JianKangguWen" placeholder="请选择">
    <el-option
      v-for="item in ddlJianKangguWen"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                
            </el-form-item> -->
            <el-form-item label="备注">
                <el-input  v-model="Remarks"></el-input>
            </el-form-item>
            
        </el-form>
       
        <div style="text-align:center">
         <el-button type="primary" :disabled="isOk" @click="cost">确定</el-button> 
        </div>
       

    </div>
    
</template>
<script>
import {restbase} from '../rest'
import {foowwLocalStorage} from '../rest'
    export default {
        name: 'info',
        data() {
            return {
                 admin:[],
              CustomerID:'0',
              PaperValue:'',
              Name:'',
              Mobile:'',
              VipLevel:'',
              isOk:false,
              Remarks:'',
                options: [{
                value: '白金',
                label: '白金会员'
                }, 
                {
                value: '钻石',
                label: '钻石会员'
                }, 
                {
                value: '黑钻',
                label: '黑钻会员'
                }],
                SexOptions: [{value: '男',
                label: '男'},{value: '女',
                label: '女'}],
                JianKangguWen:'',
                ddlJianKangguWen:[],
                product:'',
                productList:[],
                ddlproduct:[],
               
                isCard:false,
                isPaper:false,
                fullscreenLoading: false,
                IsVipLevel:true,
                PaperType:'身份证',
                IDOptions: [{value: '身份证',
                label: '身份证'},{value: '护照',
                label: '护照'}],
                 Sex:'',
                BirthDay:'',
                isSex:true,
                isBirthDay:true,

            }
  
   
        },
        created(){
           
               if (this.admin.length == 0) {
                 this.admin=JSON.parse(foowwLocalStorage.get('admin'));
                 if(this.admin==null){
                this.$alert('登录失效，请重新登录！', '错误', {
                         confirmButtonText: '确定',
                         callback: action => {
                         this.$router.push('/YBLogin');
                          }
                         });
                        
                }
               }
                if (this.productList.length == 0) {
                this.productList=JSON.parse(foowwLocalStorage.get('product'));
               }

            　
           
        },
		methods: {
            
             //身份证识别性别出生日期
             inputChange() {
      const reg =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(this.PaperValue)&&this.PaperValueValit(this.PaperValue)) {
       
        var org_gender = this.PaperValue.substring(16, 17);
        var sex = org_gender % 2 == 1 ? "男" : "女";
        this.Sex = sex;
        let birth =
          this.PaperValue.substring(6, 10) +
          "-" +
          this.PaperValue.substring(10, 12) +
          "-" +
          this.PaperValue.substring(12, 14);
        this.BirthDay = birth;
        this.PaperValueChange();
      } else {
        this.$notify.error({
          title: '错误',
          message:'身份证号码不合法'
         });
          
      }
             },
             PaperValueValit(value){
                 var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
      var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
      if (/^\d{17}\d|x$/i.test(value)) {
        var sum = 0, idx;
        for (var i = 0; i < value.length - 1; i++) {
          // 对前17位数字与权值乘积求和
          sum += parseInt(value.substr(i, 1), 10) * arrExp[i];
        }
        // 计算模（固定算法）
        idx = sum % 11;
        // 检验第18为是否与校验码相等
        if (arrValid[idx] == value.substr(17, 1).toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
       return false;
      }
             },
               PaperValueChange(){
             
                this.$http.post(restbase() + "asp/PaperChange", {
                    PaperValue: this.PaperValue
                }).then(response=>{
                    console.log(response.data.d);
                    const r = JSON.parse(response.data.d);
                    this.isPaper=true;
                    if (r.code == '0') {
                       if(r.Name!='')
                       {
                        this.Name=r.Name;
                       this.Mobile=r.Mobile;
                       this.Sex=r.Gender;
                       this.Gender=r.Gender == "男" ?'10'  : "01";
                       this.PaperType=r.PaperType;
                       }
                       this.ProductChange();
                    } 
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
             },
            
             ProductChange(){
                this.product="请选择";
                console.log(this.productList);
                this.ddlproduct=this.productList.filter(data => data.label.toLowerCase().includes(this.Sex.toLowerCase()));
               console.log(this.ddlproduct);
             },
             IDChange(){
                if(this.PaperType=='护照'){
                    this.isSex=false;
                    this.isBirthDay=false;
                    this.isPaper=true;
                }else{
                    this.isSex=true;
                    this.isBirthDay=true;
                    this.isPaper=false;
                }
             },
             SexChange(){
                this.ProductChange();
             }
             ,
             cost(){
             
                 if(this.admin.CnName==''){
                    this.$notify.error({
                            title: '错误',
                            message: '登录失效，请重新登录！'
                            ,callback: action => {
                              this.$router.push('/YBLogin');
                             }
                        });
                    return;
                }
                if(this.CustomerID==''||this.CustomerID.length<=0){
                    this.$notify.error({
                            title: '错误',
                            message: '请正确填写兑换码'
                        });
                    return;
                }
                if(this.PaperType=='' || this.PaperType=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择证件号类型'
                        });
                    return;
                }
              if((this.PaperValue==''||this.PaperValue.length!=18)&&this.PaperType=='身份证'){
                    this.$notify.error({
                            title: '错误',
                            message: '请正确填写18位身份证号码'
                        });
                    return;
                }
                if(!this.isPaper){
                    this.$notify.error({
                            title: '错误',
                            message: '卡号或身份证号未通过验证！'
                        });
                    return;
                }
                if(this.Name==''){
                    this.$alert('请正确填写客户姓名');return;
                    
                }
                if(this.Sex=='' ||this.Sex=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择客户性别'
                        });
                    return;
                }
                if(this.Mobile==''){
                    this.$notify.error({
                            title: '错误',
                            message: '请填写手机号码'
                        });
                    return;
                }
               
                
                 if(this.product==''||this.product=='请选择'){
                    this.$notify.error({
                            title: '错误',
                            message: '请选择产品'
                        });
                    return;
                }
                if( this.BirthDay==''){
                     this.$notify.error({
                            title: '错误',
                            message: '请选择生日'
                        });
                    return; 
                }
               
                
                  const loading = this.$loading({
          lock: true,
          text: '操作中，请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
                this.$http.post(restbase() + "asp/Order_YB", {
                    Card: this.CustomerID,PaperValue:this.PaperValue.toUpperCase(),Name:this.Name,Product:this.product, Mobile:this.Mobile,
                    JianKangguWen: this.admin.CnName, Remark: this.Remarks, Operater: this.admin.CnName,PaperType:this.PaperType,BirthDay:this.BirthDay,Gender:this.Sex
                }).then(response=>{
                    
                    const r = JSON.parse(response.data.d);
                    console.log(r);
                    if (r.code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r.description
                        });
                    } 
                    else {
                     
                    //  this.$confirm('出签已成功', '温馨提示', {
                    //     confirmButtonText: '预约',
                    //     cancelButtonText: '返回用户列表',
                    //     center:true,
                    //     type: 'warning'
                    //     }).then(() => {
                    //      let user={'PaperValue':this.PaperValue,'phone':this.Mobile,'name':this.Name,'product':this.product};
                    //      sessionStorage.setItem('user',JSON.stringify(row));
                    //      this.$router.push('/YBquery');
                    //     }).catch(action => {
                    //     if (action === 'cancel'){
                    //     this.$router.push('YBMember');
                    //     }
                    //     });
                        loading.close();
                        this.$alert('出签已成功', '出签', {
                        confirmButtonText: '确定',
                        callback: action => {
                        this.isOk=false;
                        this.$router.push('YBMember');
                        }
                        });
                      
                        }
                }, response=>{
                    // eslint-disable-next-line  this.$root.admin.UserName
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                    
                })
                
                
             }  
             
        },
		 watch: {
		   
            PaperValue: function () {
             if(this.PaperValue.length==18)
		     { 
                this.inputChange();
                this.ProductChange();
             }
		    },
            
         }
         
    }
</script>

<style> 
.infoframe {
        position: relative;
        height: 870px;
         width:100%;
        margin:0 auto;
        border-radius: 4px;
        border-left: 1px solid #ddd;
        box-shadow: 3px 3px 3px #aaa;
        background-color: white;
    }
    .infohead {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .infoform {
        padding: 10px 10px 10px 10px;
    }
  
   
</style>